export default __webpack_public_path__ + "static/media/wTop_3_p2.91b16764.jpeg";